import _Drawer from "@material-ui/core/esm/Drawer";
import _CircularProgress from "@material-ui/core/esm/CircularProgress";
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import classnames from 'classnames';
import React from 'react';
import { EXPAND_ICON_POSITION, MATERIAL_TRANSITION_TIME } from 'swag-client-common/constants';
import { isMobile } from 'swag-client-common/utils/ui.utils';
import { resetIntercomHorizontalPadding, setIntercomAlign, setIntercomHorizontalPadding } from '../../../utils/ui.utils';
import Header from './components/header';
import HiddenChildren from './components/hidden-children';
import classes from './drawer.scss';
const getPaperClasses = props => ({
  classes: {
    root: classnames(classes.paper, props.paperClassName)
  }
});
const drawerDefaultWidth = 460;
class Drawer extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      open
    } = prevState;
    const {
      open: nextOpen,
      anchor
    } = nextProps;
    if (nextOpen === open) {
      return null;
    }
    if (anchor !== 'right') {
      return {
        open: nextOpen
      };
    }
    if (nextOpen) {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      isMobile() ? setIntercomAlign(true) : setIntercomHorizontalPadding(drawerDefaultWidth + 20);
    } else {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      isMobile() ? setIntercomAlign() : resetIntercomHorizontalPadding();
    }
    return {
      open: nextOpen
    };
  }
  constructor(props, context) {
    super(props, context);
    this.state = {
      open: this.props.open
    };
  }
  render() {
    const {
      children,
      open,
      headerTitle,
      overlayZIndex = 10,
      anchor = 'right',
      containerClassName = '',
      headerClassName = '',
      closeButtonStyle = {},
      buttonText = '',
      buttonClassName = '',
      closeClassName = '',
      dataDrawer = '',
      bodyClassName = '',
      isButtonShown = false,
      isButtonDisabled = true,
      isExpandable = false,
      isExpandButtonShown = false,
      expandIconPosition = EXPAND_ICON_POSITION.up,
      MiddleBlock = null,
      onButtonClick,
      onClose,
      isLoading = false,
      prerenderForCrawlers = false,
      transitionTime = MATERIAL_TRANSITION_TIME,
      variant = 'temporary',
      fullHeightHolder = false
    } = this.props;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Drawer, {
      open: open,
      variant: variant,
      transitionDuration: {
        enter: transitionTime,
        exit: transitionTime
      },
      anchor: anchor,
      className: classnames(classes.infoContainer, containerClassName),
      onClose: onClose,
      PaperProps: getPaperClasses(this.props),
      "data-drawer": dataDrawer,
      style: {
        zIndex: overlayZIndex
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames({
        [classes.loading]: isLoading,
        [classes.fullHeightHolder]: fullHeightHolder
      })
    }, isLoading && /*#__PURE__*/React.createElement(_CircularProgress, {
      style: {
        zIndex: overlayZIndex
      },
      className: classes.progress
    }), /*#__PURE__*/React.createElement(Header, {
      isCloseShown: open,
      isButtonShown: isButtonShown,
      isExpandButtonShown: isExpandButtonShown,
      isExpandable: isExpandable,
      expandIconPosition: expandIconPosition,
      titleClassName: headerClassName
      // @todo. auto generated. fix this error
      // @ts-ignore
      ,
      title: headerTitle,
      closeButtonStyle: closeButtonStyle,
      buttonText: buttonText,
      buttonClassName: buttonClassName,
      MiddleBlock: MiddleBlock,
      isButtonDisabled: isButtonDisabled,
      closeClassName: closeClassName,
      onClose: onClose
      // @todo. auto generated. fix this error
      // @ts-ignore
      ,
      onButtonClick: onButtonClick
    }), /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.body, bodyClassName)
    }, children))), prerenderForCrawlers && /*#__PURE__*/React.createElement(HiddenChildren, {
      dataToDisplay: children
    }));
  }
}
_defineProperty(Drawer, "defaultProps", {
  anchor: 'right'
});
export default Drawer;